import Chart from "chart.js/auto";
import classNames from "classnames";
import { useEffect, useRef } from "react";

interface DoughnutChartProps {
  data: { labels: string[]; values: number[] };
  canvasStyle?: any;
}

const DoughnutChart = ({ data, canvasStyle }: DoughnutChartProps) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstanceRef = useRef<any>(null);

  useEffect(() => {
    const ctx = chartRef.current?.getContext("2d");

    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    if (ctx) {
      chartInstanceRef.current = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: data.labels,
          datasets: [
            {
              label: "Doughnut Dataset",
              data: data.values,
              backgroundColor: ["#EF437B", "#9A469B"],
              borderColor: ["#EF437B", "#9A469B"],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: "90%",
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    }

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [data]);

  return (
    <div style={{ position: "relative", width: "126px", height: "126px" }}>
      <canvas
        ref={chartRef}
        className={classNames(canvasStyle && canvasStyle)}
      ></canvas>
    </div>
  );
};

export default DoughnutChart;
